export enum FamilyHubAppStatus {
    NotAdded = "Not Added",
    Pending = "Pending",
    ReadOnly = "Read Only",
    Activated = "App Activated"
}
